/**
 * Soporte — entrada del menú pedida por el propietario el 2026-09-21.
 *
 * Primero la ayuda paso a paso con su buscador (`CentroDeAyuda`, pedido el
 * 2026-10-24): es la misma guía que faktelio.com/ayuda/. Debajo, la vía de
 * contacto real: el email de soporte, si está configurado en `i18n/es.ts`.
 * Sin email configurado no se inventa ninguno. Los tickets con plazo siguen
 * siendo `OD-0023`.
 *
 * La guía se carga al abrir Soporte y no con la aplicación: son unos 50 kB que
 * el resto de pantallas no necesita. Con `import()` a mano y no con
 * `React.lazy`: sin red, o con una versión nueva desplegada, el trozo puede no
 * llegar, y `lazy` lanzaría el error hasta la raíz y se llevaría la aplicación
 * entera. Así solo falla la ayuda, y dice dónde leerla.
 */
import { useEffect, useState, type ComponentType } from "react";
import { t } from "../i18n/es";
import { Aviso, Tarjeta } from "../ui/primitivas";
import { PantallaAcercaDe } from "./PantallaAcercaDe";

function useCentroDeAyuda(): ComponentType | null | "error" {
  const [centro, setCentro] = useState<ComponentType | null | "error">(null);
  useEffect(() => {
    let vivo = true;
    import("./CentroDeAyuda").then(
      (m) => vivo && setCentro(() => m.CentroDeAyuda),
      () => vivo && setCentro("error"),
    );
    return () => {
      vivo = false;
    };
  }, []);
  return centro;
}

export function PantallaSoporte() {
  const email = t.soporte.email;
  const CentroDeAyuda = useCentroDeAyuda();
  return (
    <>
    {CentroDeAyuda === null ? (
      <p className="ayuda-neutra">{t.soporte.ayudaCargando}</p>
    ) : CentroDeAyuda === "error" ? (
      <Aviso tono="error">
        {t.soporte.ayudaSinCargar} <a href={t.soporte.ayudaWebUrl}>{t.soporte.ayudaWebUrl}</a>
      </Aviso>
    ) : (
      <CentroDeAyuda />
    )}
    <Tarjeta titulo={t.soporte.titulo}>
      <p>{t.soporte.detalle}</p>
      {email.length > 0 ? (
        <p>
          {t.soporte.escribenos} <a href={`mailto:${email}`}>{email}</a>
        </p>
      ) : (
        <p>{t.soporte.sinEmail}</p>
      )}
    </Tarjeta>
    {/* Q-04: la declaración responsable, "Ayuda" / "Acerca de" (FAQ AEAT). */}
    <PantallaAcercaDe />
    </>
  );
}
